export default __webpack_public_path__ + "static/media/theme5.15468099.jpg";